import React, { Component } from 'react';

import { LOOM_URI } from 'constants/routes';
import * as clipboard from 'utilities/clipboard';

import './styles.less';

// Show 'link copied' for this many ms before disappearing
const LINK_COPY_MSG_TIMEOUT = 2000;

class CopyLinkItem extends Component {
  static defaultProps = {
    onClick: () => {},
  };

  state = { copied: null };

  render() {
    const { video } = this.props;
    const { copied } = this.state;

    const classNames = ['copy-link-item', this.state.copied && 'success']
      .filter(Boolean)
      .join(' ');

    return (
      <li className={classNames} onClick={this.handleClick}>
        <div className="icon" />
        <span>
          {copied === null && 'Link'}
          {copied === true && 'Link copied!'}
          {copied === false && 'Error, try again'}
        </span>
        <input
          ref={input => (this.input = input)}
          readOnly
          value={`${LOOM_URI}/share/${video.id}`}
        />
      </li>
    );
  }

  handleClick = event => {
    event.stopPropagation();

    clipboard.selectNodeText(this.input);

    const didCopy = clipboard.copy(this.input);

    // 1. Display status msg
    // 2. (wait 2s)
    // 3. Reset status msg
    // 4. Trigger onClick()
    this.setState({ copied: didCopy }, () => {
      setTimeout(() => {
        this.setState({ copied: null }, () => {
          this.props.onClick(event, didCopy);
        });
      }, LINK_COPY_MSG_TIMEOUT);
    });
  };
}

export default CopyLinkItem;
